import Carousel from './src/main';

export default Carousel;
